import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SelectKontokt from "../SkapaMote/Inputs/SelectKontokt";
import KontaktFName from "../SkapaMote/Inputs/KontaktFName";
import KontaktLName from "../SkapaMote/Inputs/KontaktLName";
import KontaktTele from "../SkapaMote/Inputs/KontaktTele";
import KontaktEmail from "../SkapaMote/Inputs/KontaktEmail";
import KontaktPersonnummer from "../SkapaMote/Inputs/KontaktPersonnummer";
import SelectMedArbetare from "../SkapaMote/Inputs/SelectMedArbetare";
//import BusinessIcon from '@material-ui/icons/Business';
import Divider from "@material-ui/core/Divider";
import {FormGroup,FormControlLabel,Switch } from '@material-ui/core'
//import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));


function Kontakt(props) {
  //  const classes = useStyles();
    return (
        <div>
            <div style={{ paddingTop: '5px' }} className="row">

                <div className="col-12 my-2"  style={{ height: 'auto' }}>
                <FormGroup>
                    <FormControlLabel 
                    control={<Switch defaultChecked 
                        checked={  parseInt(props.isPrivat) === 1 ? true : false } 
                        onChange={(e)=>{props.onChangeisPrivat(e.target.checked?1:0)}}
                    />} 
                    label={<IntlMessages id="Private"/>}
                    />
                </FormGroup>
                </div>
                <div className="col-12 my-2"  style={{ height: 'auto' }}>
                    <SelectKontokt 
                   Kontakter={props.Kontakter}
                   Kontokt={props.Kontakt}
                   onchangeHanelKontakt={props.onchangeHanelKontakt}
                    />
                </div>
                {
                  props.Kontakt.id === ""?"":
                  <>
                  <div className="col-6  my-2"  style={{ height: 'auto' }}>
                    <KontaktFName
                    id={props.Kontakt.id}
                    FirstName={props.Kontakt.FirstName}
                    onchangeHanelKontakt={props.onchangeHanelKontakt2}
                    />
                </div>
                <div className="col-6  my-2"  style={{ height: 'auto' }}>
                    <KontaktLName
                    id={props.Kontakt.id}
                    LastName={props.Kontakt.LastName}
                    onchangeHanelKontakt={props.onchangeHanelKontakt2}
                    />
                </div>
                <div className="col-6  my-2"  style={{ height: 'auto' }}>
                    <KontaktTele
                    id={props.Kontakt.id}
                    Tele={props.Kontakt.Tele}                    
                    onchangeHanelKontakt={props.onchangeHanelKontakt2}
                    />
                </div>
                <div className="col-6  my-2"  style={{ height: 'auto' }}>
                    <KontaktEmail
                    id={props.Kontakt.id}
                    Email={props.Kontakt.Email}
                    onchangeHanelKontakt={props.onchangeHanelKontakt2}
                    />
                </div>
                <div className="col-6  my-2"  style={{ height: 'auto' }}>
                    <KontaktPersonnummer
                    id={props.Kontakt.id}
                    Personnummer={props.Kontakt.PersonNr}
                    onchangeHanelKontakt={props.onchangeHanelKontakt2}
                    />
                </div>
                
                <div className="col-12" style={{ paddingTop: '5px', paddingBottom: '10px' }}>
                <Divider />
                </div></>   
                }
                <div className="col-12  my-2"  style={{ height: 'auto' }}>
                    <SelectMedArbetare
                    Ansvarig={props.ansvarig}
                    disabled={true}
                    />
                </div>
                <div className="col-12" style={{ paddingTop: '5px', paddingBottom: '10px' }}>
                <Divider />
                </div>
                  
            </div>
          
            
        </div>
    );
}

export default Kontakt;